import { useMemo } from 'react';
import Typography from '@alltrails/core/components/Typography';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import Carousel from '@alltrails/denali/components/Carousel';
import ActivityRiverItem from './ActivityRiverItem';
import styles from './styles.module.scss';

type Activity = {
  filters: {
    activity: string[];
  };
  photo_urls: {
    square: {
      two: string;
      three: string;
    };
  };
  title: string;
};

type Props = {
  activities?: Activity[];
  windowWidth?: number | null;
  title: string;
};

const ActivitiesRiver = ({ activities = [], windowWidth: _windowWidth = null, title }: Props) => {
  const languageRegionCode = useLanguageRegionCode();

  const activityItems = useMemo(
    () =>
      activities.map(activity => ({
        ...activity,
        props: {
          title: activity.title,
          imgSrc: activity.photo_urls.square.two,
          url: wrapUrlSafe(`/explore`, languageRegionCode),
          activityUid: activity.filters.activity[0]
        }
      })),
    [activities, languageRegionCode]
  );

  const renderItem = (item: (typeof activityItems)[0]) => <ActivityRiverItem {...item.props} />;

  const getItemKey = (item: (typeof activityItems)[0]) => item.title;

  return (
    <div className={styles.container}>
      <Typography className={styles.activitiesTitle} variant="heading400" component="h2">
        {title}
      </Typography>
      <div className={styles.riverContainer}>
        <Carousel
          uniqueId="activities-river"
          items={activityItems}
          renderItem={renderItem}
          getItemKey={getItemKey}
          className={styles.carousel}
          leftArrowClassName={styles.leftArrow}
          rightArrowClassName={styles.rightArrow}
          absoluteSizing
          slideAsSet
          showPaginationDots={false}
          showOverflow={false}
        />
      </div>
    </div>
  );
};

export default ActivitiesRiver;
